import React, { Component, PropTypes } from 'react';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';

const photos1 = [
  { src: '../assets/images/projects/PF331.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/PF332.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/PF333.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/PF334.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/PF335.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/PF336.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/PF337.jpg', width: 3, height: 4 },
  { src: '../assets/images/projects/PF338.jpg', width: 3, height: 4 }
];

const photos2 = [
  { src: '../assets/images/projects/PV1.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/PV2.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/PV3.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/PV4.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/PV5.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/PV6.jpg', width: 4, height: 3 },
  { src: '../assets/images/projects/PV7.jpg', width: 3, height: 4 },
];

export default class FutureProjects extends Component {
  constructor(props) {
    super(props)
    this.state = { currentImage: 0 };
    this.closeLightbox1 = this.closeLightbox1.bind(this);
    this.openLightbox1 = this.openLightbox1.bind(this);
    this.closeLightbox2 = this.closeLightbox2.bind(this);
    this.openLightbox2 = this.openLightbox2.bind(this);

    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }

  openLightbox1(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen1: true,
    });
  }
  closeLightbox1() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen1: false,
    });
  }

  openLightbox2(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen2: true,
    });
  }
  closeLightbox2() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen2: false,
    });
  }
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  render() {

    return (
      <div className="col-sm-12">
        <h3>Proiecte viitoare</h3>
        <section className="category cc-articles">

        <div className="i" id="articles">
          <h3 className="category__title category__title--lozenge"><span>Proiect in desfasurare</span></h3>
          <div className="item item--issue item--link">
            <p className="text-justify">1. Construcția unei case pentru șase copilaș care locuiesc într-o casă din pământ. La fiecare ploaie sau vreme rea se surpă câte puțin, . Ne dorim să le construim și lor o casă mai rezistentă.</p>
          </div>
        </div>
        <div className="item item--issue item--link">
          <Gallery photos={photos1} onClick={this.openLightbox1} />
          <Lightbox images={photos1}
            onClose={this.closeLightbox1}
            onClickPrev={this.gotoPrevious}
            onClickNext={this.gotoNext}
            currentImage={this.state.currentImage}
            isOpen={this.state.lightboxIsOpen1}
          />
        </div>

        <div className="i" id="articles">
          <h3 className="category__title category__title--lozenge"><span>Proiect in desfasurare</span></h3>
          <div className="item item--issue item--link">
            <p className="text-justify">2. Renovarea unei case pentru 5 copii care locuiesc tot intr-o casă din pământ momentan, dar care au achiziționat o casă care necesita renovare și reparații majore.</p>
          </div>
        </div>

        <div className="i" id="articles">
          <h3 className="category__title category__title--lozenge"><span>Proiect in desfasurare</span></h3>
          <div className="item item--issue item--link">
            <p className="text-justify">3. Repararea și renovarea unei case a unei familii cu trei copii. Casa e in pericol să se dărâme.</p>
          </div>
        </div>
        <div className="item item--issue item--link">
          <Gallery photos={photos2} onClick={this.openLightbox2} />
          <Lightbox images={photos2}
            onClose={this.closeLightbox2}
            onClickPrev={this.gotoPrevious}
            onClickNext={this.gotoNext}
            currentImage={this.state.currentImage}
            isOpen={this.state.lightboxIsOpen2}
          />
        </div>
        </section>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/screens/Projects/futureprojects.js